import App from './allFeaturedRatesHolder.vue'
import appInit from "../shared/app-init"
import { library as faLibrary } from '@fortawesome/fontawesome-svg-core'
import { faTrophyAlt } from '@fortawesome/pro-solid-svg-icons'
 
faLibrary.add(faTrophyAlt)
appInit(App, "#allFeaturedRatesHolder", true);